import React from 'react'
import { formatEuro, formatInt, formatPercent } from '../../../shared/lib/formatNumberDe'
import type { DashboardKpis as Kpis } from '../../../entities/dashboard'

const tile = 'flex min-w-0 flex-col gap-1.5 rounded-2xl border border-slate-200 bg-white p-4 md:px-[18px]'
const label = "font-['Roboto'] text-xs font-medium uppercase tracking-wide text-slate-500"
const value = 'text-[34px] font-bold leading-[38px] text-[#124093] tabular-nums md:text-[40px] md:leading-[44px]'
const sub = "font-['Roboto'] text-sm text-gray-500"

export const DashboardKpis: React.FC<{ kpis: Kpis }> = ({ kpis }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
    <div className={tile}>
      <span className={label}>Aufträge im Zeitraum</span>
      <span className={value}>{formatInt(kpis.orders)}</span>
      <span className={sub}>
        <b className="font-medium text-gray-800">{formatInt(kpis.completed)}</b> abgeschlossen ·{' '}
        <b className="font-medium text-gray-800">{formatInt(kpis.open)}</b> offen
      </span>
    </div>
    <div className={tile}>
      <span className={label}>Kosten Ist</span>
      <span className={value}>{formatEuro(kpis.istEuro)}</span>
      <span className={sub}>
        von <b className="font-medium text-gray-800">{formatEuro(kpis.sollEuro)}</b> Soll ·{' '}
        <b className="font-medium text-gray-800">{formatPercent(kpis.euroRatio)}</b>
      </span>
      <div
        className="mt-1 h-1.5 overflow-hidden rounded-[3px] bg-gray-200"
        role="progressbar"
        aria-label="Kosten Ist von Soll"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.min(100, Math.round(kpis.euroRatio))}
      >
        <div className="h-full rounded-[3px] bg-[#004494]" style={{ width: `${Math.min(100, kpis.euroRatio)}%` }} />
      </div>
    </div>
  </div>
)
